var currentURL = $(location).attr("href");
var str2 = "/products/anxiety-relief";
var str3 = "/products/natural-sugar-control";
if(currentURL.indexOf(str2) != -1){
  window.location.href = '/pages/coming-soon'; 
}
if(currentURL.indexOf(str3) != -1){
  window.location.href = '/pages/coming-soon'; 
}


$(window).on('load', function () {
  if (window.location.hostname !== 'manage.budandnectar.com') {
    return;
  }

  var loginSection = $('section.rc-login');

  if (loginSection.length && !$('.bn-manage-intro').length) {
    $('<div class="bn-manage-intro">' +
      '<h1>Manage your subscription</h1>' +
      '<p>View upcoming deliveries and manage your subscription.</p>' +
      '</div>').insertBefore(loginSection);
  }
});

var myVar = setInterval(myTimer, 500);
function myTimer() {
  if( $('#judgeme_product_reviews .jdgm-rev-widg__reviews .jdgm-rev__header-custom-form').length ) {
    console.log('custom review');
     $("#judgeme_product_reviews .jdgm-rev-widg__reviews .jdgm-rev .jdgm-rev__header-custom-form").each(function(){
      var ans = $(this).find('.jdgm-rev__cf-ans__value').text();
       if(ans == 'Yes'){
         $(this).find('.jdgm-rev__cf-ans__title').text('I recommend this product');
         $(this).find('.jdgm-rev__cf-ans__value').css('display','none');
       }else{
         $(this).css('display','none');
       }
    }); 

    
    clearInterval(myVar);
  }
}


$(document).ready(function(){

    $('.gallery-lp').slick({
    dots: false,
    slidesToShow: 6,
    centerPadding: '20px',
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
    nextArrow: '<span class="arrow-next arrow-btn"><i class="fa fa-angle-right" aria-hidden="true"></i></span>',
    prevArrow: '<span class="arrow-prev arrow-btn"><i class="fa fa-angle-left" aria-hidden="true"></i></span>',
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3
        }
      },
       {
        breakpoint: 479,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  


  $(".videoPlayNov .openVideo").click(function (e) {
     var videoPlay =  $(this).parent().prev();

     var otherVideo = $('.customers-say-list video');
     otherVideo.not(videoPlay).get(0).pause();

     $('.videoPlayNov').css('display','flex');
     $('.testimonials__slide_card_bottom').css('display','flex');
     $(this).parent().css('display','none');
     $(this).parent().next().css('display','none');
    if (videoPlay.get(0).paused) {
        videoPlay.get(0).play();
    }
    else {
        videoPlay.get(0).pause();
    }
    e.preventDefault();
  });

    $(".videoControl span").click(function (e) {
     var videoItem =  $(this).parent().prev();

     var otherVideo = $('.customers-say-list video');
     otherVideo.not(videoItem).get(0).pause();

     $(this).parent().toggleClass('play');
    if (videoItem.get(0).paused) {
        videoItem.get(0).play();
      }
      else {
          videoItem.get(0).pause();
      }
    e.preventDefault();
  });

  

  
  $('.rvSlider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay:true,
    autoplaySpeed:5000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: true,
          slidesToShow: 2,
          nextArrow: '<span class="arrow-next arrow-btn"><img src="https://cdn.shopify.com/s/files/1/0717/9734/2516/files/review_arrow_12_24.svg?v=1695282485"></span>',
          prevArrow: '<span class="arrow-prev arrow-btn"><img src="https://cdn.shopify.com/s/files/1/0717/9734/2516/files/review_arrow_12_24.svg?v=1695282485"></span>',
        }
      },
      {
        breakpoint: 640,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '30px',
          slidesToShow: 1
        }
      }
    ]
  
  });


  $('.open-popup-link').magnificPopup({
    type:'inline',
    midClick: true
  });

mobileOnlySlider(".multicolumn-slide-mb", true, false, 767, );

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
      arrows: false,
        centerMode: true,
        centerPadding: '50px',
		mobileFirst: true,
		dots: false,
		arrows: $arrows,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};

	slider.slick(settings);

	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
} // Mobile Only Slider

$('.reviews-slider').slick({
  slidesToShow: 1,
  autoplay:true,
  autoplaySpeed:5000,
  adaptiveHeight: false,
  nextArrow: '<span class="arrow-next arrow-btn"><i class="fa fa-angle-right" aria-hidden="true"></i></span>',
  prevArrow: '<span class="arrow-prev arrow-btn"><i class="fa fa-angle-left" aria-hidden="true"></i></span>',
});

mobileOnlySliderNov1(".customers-say-list", true, false, 749, );

function mobileOnlySliderNov1($slidername, $dots, $arrows, $breakpoint) {
	var slider = $($slidername);
	var settings = {
        arrows: true,
        centerMode: true,
        centerPadding: '50px',
        loop: false,
		mobileFirst: true,
		dots: false,
        infinite: false,
		arrows: $arrows,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};

	slider.slick(settings);

	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
} // Mobile Only Slider


  
  
  
//index product tab js
    $('#mobile_slider_nav').slick({
    focusOnSelect: true,
    dots: false,
    slidesToShow: 1,
    arrows: false,
    infinite: false,
    asNavFor: '#mobile_slider',
    centerPadding: '75px',
     centerMode: true
  });

  $('#mobile_slider').slick({
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 3,
    loop:false,
    infinite: false,
    asNavFor: '#mobile_slider_nav',
    dots: true,
    customPaging: function(slick,index) {
        var targetText = slick.$slides.eq(index).find('.heading_tab').text();
        return '<span>' + targetText + '</span>';
    },
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '30px',
          slidesToShow: 1
        }
      },
      {
        breakpoint: 639,
        settings: {
          dots: false,
          arrows: false,
          centerMode: true,
          centerPadding: '30px',
          slidesToShow: 1
        }
      }
    ]
  });
  
  $('#mobile_slider_nav').on('afterChange', function(event, slick, currentSlide, nextSlide){
    var dataId = $(slick.$slides[currentSlide]).attr('data-slick-index');  
    
    $("#mobile_slider_nav").removeClass(function (index, classNames) {
      var current_classes = classNames.split(" "), 
          classes_to_remove = [];
  
      $.each(current_classes, function (index, class_name) {
        if (/active.*/.test(class_name)) {
          classes_to_remove.push(class_name);
        }
      });
      return classes_to_remove.join(" ");
    });
    $("#mobile_slider_nav").addClass('active-'+dataId);
  });


  //scroll

   var headH = $('.header-wrapper').outerHeight();
   var stickyH = $('.sticky_mb').outerHeight();
   var scrollH = headH + stickyH;

  console.log('scrollH='+scrollH);
  // Select all links with hashes
  $('#product_accordion .accordion-body a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - scrollH
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });

    // Select all links with hashes
  $('#product_accordion .accordion-content1 a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - headH
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });

  var windowWidth = $(window).width();
  var productImageHeight = $('.main-sliderPro').outerHeight();
  var halfheight = parseInt(productImageHeight) / 2;
  var scrollTopMobile = parseInt(halfheight) + 20;
  console.log('scrollTopMobile='+scrollTopMobile);
  
   $(window).resize(function() {
    if (windowWidth <= 749) {
         // Select all links with hashes
        $('a.get-deep-sleep[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
          // On-page links
          if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
            && 
            location.hostname == this.hostname
          ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
              // Only prevent default if animation is actually gonna happen
              event.preventDefault();
              $('html, body').animate({
                scrollTop: target.offset().top + scrollTopMobile
              }, 1000, function() {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                $target.focus();
                if ($target.is(":focus")) { // Checking if the target was focused
                  return false;
                } else {
                  $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                  $target.focus(); // Set focus again
                };
              });
            }
          }
        });
    }else{
       // Select all links with hashes
      $('a.get-deep-sleep[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
          && 
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000, function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              };
            });
          }
        }
      });
    }
  });

  $(window).on('load', function () {
    if (windowWidth <= 749) {
         // Select all links with hashes
        $('a.get-deep-sleep[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
          // On-page links
          if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
            && 
            location.hostname == this.hostname
          ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
              // Only prevent default if animation is actually gonna happen
              event.preventDefault();
              $('html, body').animate({
                scrollTop: target.offset().top + scrollTopMobile
              }, 1000, function() {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                $target.focus();
                if ($target.is(":focus")) { // Checking if the target was focused
                  return false;
                } else {
                  $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                  $target.focus(); // Set focus again
                };
              });
            }
          }
        });
    }else{

      // Select all links with hashes
      $('a.get-deep-sleep[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
          && 
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000, function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              };
            });
          }
        }
      });
      
    }
  });


});






